import { api } from './api';
import { ChatMessage } from '../types/mundus';

export interface SendMessageInput {
  content: string;
  agentId?: string;
}

export interface SendMessageResponse {
  success: boolean;
  data: {
    userMessage: ChatMessage;
    assistantMessage: ChatMessage;
  };
}

export interface GetMessagesResponse {
  success: boolean;
  data: ChatMessage[];
}

export interface UnreadCountResponse {
  success: boolean;
  data: {
    count: number;
  };
}

/**
 * Send a message to an agent
 */
export const sendMessage = async (
  mundusId: string,
  input: SendMessageInput
): Promise<SendMessageResponse> => {
  const response = await api.post(`/api/mundus/${mundusId}/messages`, input);
  return response.data;
};

/**
 * Get message history for a Mundus
 */
export const getMessages = async (
  mundusId: string,
  agentId?: string,
  limit?: number,
  offset?: number
): Promise<ChatMessage[]> => {
  const params = new URLSearchParams();
  if (agentId) params.append('agentId', agentId);
  if (limit) params.append('limit', limit.toString());
  if (offset) params.append('offset', offset.toString());

  const response = await api.get<GetMessagesResponse>(
    `/api/mundus/${mundusId}/messages?${params.toString()}`
  );
  return response.data.data;
};

/**
 * Mark messages as read
 */
export const markMessagesAsRead = async (messageIds: string[]): Promise<void> => {
  await api.post('/api/messages/mark-read', { messageIds });
};

/**
 * Get unread message count
 */
export const getUnreadCount = async (
  mundusId: string,
  agentId?: string
): Promise<number> => {
  const params = new URLSearchParams();
  if (agentId) params.append('agentId', agentId);

  const response = await api.get<UnreadCountResponse>(
    `/api/mundus/${mundusId}/messages/unread-count?${params.toString()}`
  );
  return response.data.data.count;
};
